import * as React from 'react';

import { FlatButton, FontIcon, TableRow, TableRowColumn } from 'material-ui';

import { Beacon } from 'glance-datatypes';
import { BeaconType } from '../types';
import Utils from '../../../Utils';
import {
  styles,
} from '../styles/draftDetailsStyle';
import { red500, green500, amber500, fullBlack, blueGrey500 } from 'material-ui/styles/colors';

interface BeaconTableRowProps {
  beaconType: BeaconType;
  beaconList: Beacon[];
  index: number;
  beaconItem: Beacon;
  removeBeacon: Function;
  s2sFlag: Boolean;
}

type IsValidType = 'check' | true | false;

interface State {
  isValid: IsValidType;
}

class BeaconTableRow extends React.Component<BeaconTableRowProps, State> {
  constructor(props: BeaconTableRowProps) {
    super(props);
    this.state = {
      isValid: 'check',
    }
  }

  checkBeaconUrlValidity = (beaconUrl, s2sFlag) => {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: `https://beacons.glance.inmobi.com/beacon/validateBeacon?ctx=cta&s2s=${s2sFlag}`,
        data: JSON.stringify({urls:[
           beaconUrl,
        ]}),
        contentType: 'application/json',
        success: function (dataResponse) {
          const isValid = dataResponse[0];
          resolve(isValid);
        },
        error: function (error) {
          reject(error);
        },
      });
    })
  }



  componentWillMount(){
    this.checkBeaconUrlValidity(this.props.beaconItem.url, this.props.s2sFlag)
    .then((isValid) => {
      this.setState({
        isValid: isValid as boolean,
      });
    })
    .catch((err) => {
    });;
  }

  componentWillReceiveProps(nextProps: BeaconTableRowProps) {
    if(nextProps.beaconItem.url !== this.props.beaconItem.url || nextProps.s2sFlag !== this.props.s2sFlag){
      this.setState({
        isValid: 'check',
      });
      this.checkBeaconUrlValidity(nextProps.beaconItem.url, nextProps.s2sFlag )
      .then((isValid) => {
        this.setState({
          isValid: isValid as boolean,
        });
      })
      .catch((err) => {
      });;
  }
}

  render() {
    const {
      beaconType,
      beaconList,
      index,
      beaconItem,
      removeBeacon,
    } = this.props;
    const {isValid} = this.state;
    const isBeaconURLError = Utils.isValidBeaconURL(
        beaconItem.url,
        beaconType,
        beaconItem.beaconPartner,
      );

    return (
      <TableRow selectable={false} key={beaconType + '_' + index} style={{ ...styles.width100, height: '48px'}} >
        <TableRowColumn style={{ maxWidth: '150px', wordWrap: 'break-word', whiteSpace:'normal', padding: '0 10px 0 0' }}>
          {BeaconType[beaconType]}
          <h6>{beaconItem.beaconPartner !== 'None' ? beaconItem.beaconPartner : ''}</h6>
        </TableRowColumn>
        <TableRowColumn style={{ maxWidth: '300px', whiteSpace: 'normal' ,padding: '0 10px', width: '300px',wordWrap: 'break-word', }}>
          {beaconItem.url}
          {isBeaconURLError ? (
            <span>
              <hr style={{margin: 0}} />
              <span style={{ color: 'red' }}>
                {'Beacon URL may not be correct please check'}
              </span>
            </span>
          ) : (
            ''
          )}
        </TableRowColumn>
        <TableRowColumn style={{ width: '26px',wordWrap: 'break-word', padding: 0}}>
          { isValid === true ? (<FontIcon
            className="material-icons"
            color={green500}
            style={{ fontSize: '2em' , display: 'block',width: '26px'}}
          >
            check
          </FontIcon>):
            isValid === false ? 
            ( <FontIcon
            className="material-icons"
            color={red500}
            style={{ fontSize: '2em',width: '26px' }}
          >
            close
          </FontIcon>): 
          (<FontIcon
            className="material-icons"
            color={blueGrey500}
            style={{ fontSize: '2em',width: '26px' }}
          >
            pending
          </FontIcon>)
          }
        </TableRowColumn>
        <TableRowColumn
          style={{
            width: '100px',
            maxWidth: '100px',
            wordWrap: 'break-word',
            padding: '0 10px',
            textAlign: 'center'
          }}
        >
          {`${beaconItem.minDurationInSecs}/${beaconItem.delayDurationInMillis}`}
        </TableRowColumn>

        <TableRowColumn style={{ maxWidth: '80px', wordWrap: 'break-word' , paddingLeft: '0', paddingRight:'0'}}>
          {
            <FlatButton
              onClick={(e) => removeBeacon(beaconType, beaconList, index)}
            >
              DELETE
            </FlatButton>
          }
        </TableRowColumn>
      </TableRow>
    );
  }
}

export default BeaconTableRow;



// WEBPACK FOOTER //
// ./src/pages/drafts/components/BeaconTableRow.tsx